import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { connect } from 'react-redux';
import { compose } from 'redux';

import { createStructuredSelector } from 'reselect';

import history from 'utils/history/historyObject';

import { makeSelectHasFutureCDFs, makeSelectHasPastCDFs } from 'containers/App/selectors.js';

import Button from 'components/Button';

const HistoryControl = styled.div`
  vertical-align: top;
  height: 100%;
  display: flex;
  flex-direction: row;
`;


export const DirectionButton = styled(Button)`
  --default-background: transparent;
  --default-color: ${(props) => props.theme.brandPurple};
  --hover-background: ${(props) => props.theme.brandDark};
  --hover-color: #ffffff;
  --disabled-background: var(--default-background);
  --disabled-color: ${(props) => props.theme.lightGrey};

  &[disabled] {
    cursor: default;
    i, &:hover i {
      color: inherit;
    }
  }
`;

const HistoryControls = ({ hasFutureCDFs, hasPastCDFs }) => (
  <HistoryControl>
    <DirectionButton
      onClick={history.goBack}
      disabled={!hasPastCDFs}
    >
      <i className="glyphicon glyphicon-chevron-left" />
    </DirectionButton>
    <DirectionButton
      onClick={history.goForward}
      disabled={!hasFutureCDFs}
    >
      <i className="glyphicon glyphicon-chevron-right" />
    </DirectionButton>
  </HistoryControl>
);

HistoryControls.propTypes = {
  hasFutureCDFs: PropTypes.bool,
  hasPastCDFs: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  hasFutureCDFs: makeSelectHasFutureCDFs(),
  hasPastCDFs: makeSelectHasPastCDFs(),
});

const withConnect = connect(mapStateToProps);

export default compose(
  withConnect
)(HistoryControls);



// WEBPACK FOOTER //
// ./app/components/HistoryControls/index.js